import React from 'react';
import { Alert } from '@mui/material';

interface PayrollStatusAlertsProps {
  error: string;
  success: string;
  onClearError: () => void;
  onClearSuccess: () => void;
}

const PayrollStatusAlerts: React.FC<PayrollStatusAlertsProps> = ({
  error,
  success,
  onClearError,
  onClearSuccess
}) => {
  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={onClearError}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={onClearSuccess}>
          {success}
        </Alert>
      )}
    </>
  );
};

export default PayrollStatusAlerts;
